const SubCategory = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    "category": "Category",

    // PAGE HEADER
    "sub_category": "Sub Category",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_status": "Select Status",
    "error_category": "Select Category",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_category": "CATEGORY",
    "table_status": "STATUS",

}

export default SubCategory;